@if ($model() != null) {
    <form class="px-1" (ngSubmit)="onSubmit()" #flowObjectMidwayOutboundApi="ngForm">
        <div class="accordion scroll-wrapper styled-scrollbar px-2 pb-3">
            <!-- Configurações Básicas -->
            <div class="card">
                <!-- Header -->
                <div class="accordion-heading">
                    <h5 class="mb-0">
                        <i class="fas fa-chevron-circle-right" [class.on]=" isTabOpen(1)"></i>
                        <a class="btn btn-link" (click)="toggleTab(1)" (keyDown)="toggleTab(1)">
                            Configurações Básicas
                        </a>
                    </h5>
                </div>

                <!-- Body -->
                <div class="accordion-body card-body" [class.on]=" isTabOpen(1)">
                    <!-- Método HTTP e URL do Endpoint -->
                    <div class="form-group mb-3">
                        <div class="wrapper">
                            <div class="form-group col-2 m-0">
                                <label for="url">Método HTTP</label>

                                <select class="form-control" id="httpMethod" name="httpMethod"
                                        [ngModel]="$selectedHttpMethod()"
                                        (change)="$selectedHttpMethod.set($event.target.value)"
                                >
                                    @for (option of httpMethodOptions; track option) {
                                        <option [value]="option.value">{{option.description}}</option>
                                    }
                                </select>
                            </div>

                            <div class="form-group col m-0">
                                <label for="url">URL do Endpoint</label>
                                <input type="text" class="form-control" id="url" name="url" required #urlElem="ngModel"
                                       placeholder="e.g. &quot;https://api.siarhes.es.gov.br/tempo-servico&quot;"
                                       [ngModel]="$url()"
                                       (change)="$url.set($event.target.value)"
                                >
                                <div [hidden]="urlElem.valid || urlElem.pristine" class="alert alert-danger mt-1">Campo obrigatório</div>
                            </div>
                        </div>
                    </div>

                    <!-- Nome do Sistema de Destino -->
                    <ng-container>
                        <div class="form-group"
                             featureHint="flowObjectDetailsMidwayOutboundApi|PublicSystemName" featureHintHAlign="right" featureHintVAlign="bottom"
                        >
                            <label for="publicSystemName">Nome do Sistema de Destino</label>

                            <input type="text" class="form-control" id="publicSystemName" name="publicSystemName" required #publicSystemNameElem="ngModel"
                                   [ngModel]="$publicSystemName()"
                                   (change)="$publicSystemName.set($event.target.value)"
                            >
                        </div>
                        <div [hidden]="publicSystemNameElem.valid || publicSystemNameElem.pristine" class="alert alert-danger">Campo obrigatório</div>
                    </ng-container>

                    <!-- Mensagem de Erro Padrão -->
                    <ng-container>
                        <div class="form-group mb-3"
                             featureHint="flowObjectDetailsMidwayOutboundApi|ErrorMessage" featureHintHAlign="right" featureHintVAlign="bottom"
                        >
                            <label for="errorMessage">Mensagem de Erro Padrão</label>

                            <input type="text" class="form-control" id="errorMessage" name="errorMessage"
                                   [ngModel]="$errorMessage()"
                                   [placeholder]="'e.g. &quot;Erro ao enviar mensagem para o sistema de destino.&quot;'"
                                   (change)="$errorMessage.set($event.target.value)"
                            >
                        </div>
                    </ng-container>

                    <!-- Informar parâmetros de URL dinâmica -->
                    <div class="form-group"
                         featureHint="flowObjectDetailsMidwayOutboundApi|UseUrlParameters" featureHintHAlign="right" featureHintVAlign="bottom"
                    >
                        <mat-checkbox id="useUrlParameters" name="useUrlParameters" color="primary" class="m-0"
                                      [ngModel]="$useUrlParameters()"
                                      (change)="toggleShowParametersUrl()"
                        >Informar parâmetros de URL dinâmica</mat-checkbox>
                    </div>

                    <!-- Parâmetros de URL dinâmica -->
                    @if ($showParametersUrl()) {
                        <div class="key-value-pair-view-container">
                            <div class="form-group">
                                <div class="subsection-wrapper ml-4">
                                    <div class="form-group mb-0">
                                        <label for="parameterValueType">Parâmetro</label>
                                        <select class="form-control" id="parameterValueType" name="parameterKeyType"
                                                [ngModel]="$parameterKeyType()"
                                                (change)="$parameterKeyType.set($event.target.value); $parameterKey.set(null)"
                                        >
                                            <!--<option [value]="PairValueTypeValues.AcessoCidadaoCpf" selected>CPF</option>-->
                                            <optgroup label="Formulário">
                                                @for (entry of $formFlowObjectEntries(); track entry) {
                                                    @let val1 = PairValueTypeValues.Form
                                                        .replace('{0}', $formFlowObject().typeId)
                                                        .replace('{1}', $formFlowObject().outerIndex)
                                                        .replace('{2}', entry.key);
                                                    <option [value]="val1">{{entry.label}}</option>
                                                }
                                            </optgroup>
                                        </select>
                                    </div>

                                    <div class="form-group mb-0">
                                        <label for="parameterKey">Chave do parâmetro da URL</label>
                                        <input type="text" class="form-control" id="parameterKey" name="parameterKey"
                                               [ngModel]="$parameterKey()"
                                               [placeholder]="$parameterKeyType() == PairValueTypeValues.AcessoCidadaoCpf
                                                   ? Enums.Messages.CpfParameterTip
                                                   : $parameterKeyType() == PairValueTypeValues.AcessoCidadaoIdUsuarioSolicitante
                                                       ? Enums.Messages.IdUsuarioSolicitanteParameterTip
                                                       : $parameterKeyType() == PairValueTypeValues.AcessoCidadaoIdUsuarioExecutor
                                                           ? Enums.Messages.IdUsuarioExecutorParameterTip
                                                           : Enums.Messages.FormParameterTip
                                               "
                                               (change)="$parameterKey.set($event.target.value)"
                                        >
                                    </div>

                                    <button type="button" class="btn btn-outline-primary ml-2" (click)="addParameter()" (keyDown)="addParameter()">
                                        <i class="fas fa-plus-circle mr-2"></i>
                                        <span>Adicionar</span>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="key-value-pairs-container ml-4">
                                    @for (parameter of $keyValueParametersArray(); track parameter) {
                                        <div class="key-value-pair mr-2 mb-2 p-2">
                                            <pre class="m-0" [innerHtml]="prettyPrint(parameter)"></pre>

                                            <i class="fas fa-trash-alt ml-2" matTooltip="Remover par de chave/valor"
                                               (click)="removeParameter(parameter)"
                                               (keyDown)="removeParameter(parameter)"
                                            ></i>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    <!-- Ignorar erros de execução -->
                    <!--<div class="form-group mt-2"
                         featureHint="flowObjectDetailsMidwayOutboundApi|IgnoreErrors" featureHintHAlign="right" featureHintVAlign="bottom"
                    >
                        <mat-checkbox id="ignoreErrors" name="ignoreErrors" color="primary" class="m-0"
                                      [ngModel]="$ignoreErrors()"
                                      (change)="$ignoreErrors.set($event.checked)"
                        >Ignorar erros de execução</mat-checkbox>
                    </div>-->
                </div>
            </div>

            <!-- Autenticação -->
            <div class="card">
                <!-- Header -->
                <div class="accordion-heading">
                    <h5 class="mb-0">
                        <i class="fas fa-chevron-circle-right" [class.on]=" isTabOpen(2)"></i>
                        <a class="btn btn-link" (click)="toggleTab(2)" (keyDown)="toggleTab(2)">
                            Autenticação
                        </a>
                    </h5>
                </div>

                <!-- Body -->
                <div class="accordion-body card-body" [class.on]=" isTabOpen(2)">
                    <div class="form-group">
                        <label for="authenticationScheme">Esquema de Autenticação</label>

                        <select class="form-control" id="authenticationScheme" name="authenticationScheme"
                                [ngModel]="$authentication().authenticationScheme"
                                (change)="authenticationSchemeChangeHandler(+$event.target.value)"
                        >
                            @for (option of authenticationSchemeOptions; track option) {
                                <option [value]="option.value">{{option.description}}</option>
                            }
                        </select>
                    </div>

                    @if ([AuthenticationSchemeType.Basic, AuthenticationSchemeType.ApiKey].includes(+$authentication().authenticationScheme)) {
                        <div class="form-group ml-4">
                            @let placeholder = $authentication().authenticationScheme == AuthenticationSchemeType.Basic ? 'e.g. dXNlcm5hbWU6cGFzc3dvcmQ=' : 'e.g. abcdef12345';
                            @if ($authentication().authenticationScheme == AuthenticationSchemeType.Basic) {
                                <label for="basicOrApiKey">Token de Autenticação Básica (formato Base64)</label>
                            } @else {
                                <label for="basicOrApiKey">Token de API Key (header HTTP "X-Api-Key")</label>
                            }

                            <input type="text" class="form-control" id="basicOrApiKey" name="basicOrApiKey" #basicOrApiKeyElem="ngModel" required
                                   [ngModel]="$authentication().basicOrApiKey"
                                   [placeholder]="placeholder"
                                   (change)="basicOrApiKeyChange($event.target.value)"
                            >

                            <div [hidden]="basicOrApiKeyElem.valid || basicOrApiKeyElem.pristine" class="alert alert-danger">Campo obrigatório</div>
                        </div>
                    }

                    @if ($authentication().authenticationScheme == AuthenticationSchemeType.Jwt) {
                        <div class="form-group ml-4">
                            <label for="clientId">Client ID</label>
                            <input type="text" class="form-control" id="clientId" name="clientId" #clientIdElem="ngModel" required
                                   placeholder="e.g. 890ab991-b714-2fc2-ba31-8941fae87133"
                                   [ngModel]="$authentication().clientId"
                                   (change)="clientIdChange($event.target.value)"
                            >
                            <div [hidden]="clientIdElem.valid || clientIdElem.pristine" class="alert alert-danger">Campo obrigatório</div>
                        </div>

                        <div class="form-group ml-4">
                            <label for="clientSecret">Client Secret</label>
                            <input type="text" class="form-control" id="clientSecret" name="clientSecret" #clientSecretElem="ngModel" required
                                   placeholder="e.g. V1Tc23fsda356vvsa45bgsf6KFmPTB"
                                   [ngModel]="$authentication().clientSecret"
                                   (change)="clientSecretChange($event.target.value)"
                            >
                            <div [hidden]="clientSecretElem.valid || clientSecretElem.pristine" class="alert alert-danger">Campo obrigatório</div>
                        </div>

                        <div class="form-group ml-4">
                            <label for="scopes">Scopes</label>
                            <input type="text" class="form-control" id="scopes" name="scopes" #scopesElem="ngModel" required
                                   placeholder="e.g. &quot;openid profile email nome&quot;"
                                   [ngModel]="$authentication().scopes"
                                   (change)="scopesChange($event.target.value)"
                            >
                            <div [hidden]="scopesElem.valid || scopesElem.pristine" class="alert alert-danger">Campo obrigatório</div>
                        </div>

                        <div class="form-group ml-4">
                            <label for="tokenEndpoint">Token Endpoint</label>
                            <input type="text" class="form-control" id="tokenEndpoint" name="tokenEndpoint" #tokenEndpointElem="ngModel" required
                                   placeholder="e.g. https://acessocidadao.es.gov.br/is/connect/token"
                                   [ngModel]="$authentication().tokenEndpoint"
                            >
                            <div [hidden]="tokenEndpointElem.valid || tokenEndpointElem.pristine" class="alert alert-danger">Campo obrigatório</div>
                        </div>
                    }
                </div>
            </div>

            <!-- Corpo da Requisição -->
            <div class="card">
                <!-- Header -->
                <div class="accordion-heading">
                    <h5 class="mb-0">
                        <i class="fas fa-chevron-circle-right" [class.on]=" isTabOpen(3)"></i>
                        <a class="btn btn-link" (click)="toggleTab(3)" (keyDown)="toggleTab(3)">
                            Corpo da Requisição
                        </a>
                    </h5>
                </div>

                <!-- Body -->
                <div class="accordion-body card-body" [class.on]=" isTabOpen(3)">
                    <div class="form-group">
                        <span class="subtitle">
                            Monte aqui o conteúdo (payload em formato JSON) que será enviado no corpo da requisição para o endpoint de
                            destino. Você pode adicionar os pares de chave/valor de forma estruturada ou editar o JSON diretamente. Caso
                            queira adicionar valores de campos do formulário respondido na Tarefa inicial, utilize o modo de visualização
                            por pares de chave/valor para que as tags de substituição sejam inseridas corretamente.
                        </span>
                    </div>

                    <div class="form-group">
                        <label class="subsection-label m-0" for="modoVisualizacao">Modo de visualização</label>
                        <div class="subsection-wrapper ml-4">
                            <span class="slide-toggle-label" [class.on]="!$showJsonView()" (click)="setShowJsonView(false)" (keyDown)="setShowJsonView(false)">
                                Adicionar pares de chave/valor
                            </span>
                            <mat-slide-toggle class="mx-2" name="showJsonView" color="primary"
                                              [ngModel]="$showJsonView()"
                                              (change)="isJsonValid($event)"
                            ></mat-slide-toggle>
                            <span class="slide-toggle-label" [class.on]="$showJsonView()" (click)="setShowJsonView(true)" (keyDown)="setShowJsonView(true)">
                                Editar JSON completo
                            </span>
                        </div>
                    </div>

                    @if (!$showJsonView()) {
                        <div class="key-value-pair-view-container">
                            <div class="form-group">
                                <label class="subsection-label mb-2" for="keyValuePairs">Adicionar pares de chave/valor</label>

                                <div class="subsection-wrapper ml-4">
                                    <div class="form-group mb-0">
                                        <label for="pairValueType">Tipo do Valor</label>

                                        <select class="form-control" id="pairValueType" name="pairValueType"
                                                [ngModel]="$pairValueType()"
                                                (change)="clearKeyValueFields($event.target.value)"
                                        >
                                            <option [value]="PairValueTypeValues.AcessoCidadaoIdUsuarioSolicitante">ID de usuário do Acesso Cidadão (solicitante do Fluxo)</option>
                                            <option [value]="PairValueTypeValues.AcessoCidadaoIdUsuarioExecutor">ID de usuário do Acesso Cidadão (executor da Tarefa)</option>
                                            <option [value]="PairValueTypeValues.EDocsEnc">Protocolo E-Docs (encaminhamento)</option>
                                            <option [value]="PairValueTypeValues.EDocsProc">Protocolo E-Docs (processo)</option>
                                            <option [value]="PairValueTypeValues.SendDateTime">Data e hora de envio</option>

                                            <optgroup label="Valores">
                                                <option [value]="PairValueTypeValues.String">Texto</option>
                                                <option [value]="PairValueTypeValues.Number">Número</option>
                                                <option [value]="PairValueTypeValues.Boolean">Booleano</option>
                                                <option [value]="PairValueTypeValues.Null">Nulo</option>
                                            </optgroup>

                                            <optgroup label="Formulário">
                                                @for (entry of $formFlowObjectEntries(); track entry) {
                                                    @let val1 = PairValueTypeValues.Form
                                                        .replace('{0}', $formFlowObject().typeId)
                                                        .replace('{1}', $formFlowObject().outerIndex)
                                                        .replace('{2}', entry.key);
                                                    <option [value]="val1">{{entry.label}}</option>
                                                }
                                            </optgroup>
                                        </select>

                                        @if (isFormPairValueType()) {
                                            <i class="fas fa-question-circle"
                                               matTooltip="&quot;Valor&quot; será preenchido com o valor respondido pelo usuário no campo escolhido do formulário"
                                            ></i>
                                        }

                                        @if ($pairValueType() == PairValueTypeValues.EDocsEnc) {
                                            <i class="fas fa-question-circle"
                                               matTooltip="&quot;Valor&quot; será preenchido com o protocolo E-Docs do Encaminhamento que representa a instância de Fluxo iniciada pelo usuário"
                                            ></i>
                                        }
                                        @else if ($pairValueType() == PairValueTypeValues.EDocsProc) {
                                            <i class="fas fa-question-circle"
                                               matTooltip="&quot;Valor&quot; será preenchido com o protocolo E-Docs do Processo autuado na instância de Fluxo iniciada pelo usuário"
                                            ></i>
                                        }
                                    </div>

                                    @let placeholderKey = $pairValueType() == PairValueTypeValues.EDocsEnc || $pairValueType() == PairValueTypeValues.EDocsProc
                                        ? 'e.g. "edocs"'
                                        : $pairValueType() == PairValueTypeValues.String
                                            ? 'e.g. "nome"'
                                            : $pairValueType() == PairValueTypeValues.Number
                                                ? 'e.g. "categoriaId"'
                                                : $pairValueType() == PairValueTypeValues.Boolean
                                                    ? 'e.g. "flagAtivo"'
                                                    : $pairValueType() == PairValueTypeValues.Null
                                                        ? 'e.g. "conteudo"'
                                                        : $pairValueType() == PairValueTypeValues.AcessoCidadaoIdUsuarioSolicitante
                                                            ? 'e.g. idUsuarioSolicitante'
                                                            : $pairValueType() == PairValueTypeValues.AcessoCidadaoIdUsuarioExecutor
                                                                ? 'e.g. idUsuarioExecutor'
                                                                : 'e.g. "' + getFormFieldKey() + '"';
                                    <div class="form-group mb-0">
                                        <label for="pairKey">Chave</label>
                                        <input type="text" class="form-control" id="pairKey" name="pairKey"
                                               [placeholder]="placeholderKey"
                                               [ngModel]="$pairKey()"
                                               (change)="$pairKey.set($event.target.value)"
                                        >
                                    </div>

                                    @let placeholderValue = $pairValueType() == PairValueTypeValues.EDocsEnc
                                        ? 'e.g. "2021-A1B2C3"'
                                        : $pairValueType() == PairValueTypeValues.EDocsProc
                                            ? 'e.g. "2021-A1B2C"'
                                            : $pairValueType() == PairValueTypeValues.String
                                                ? 'e.g. "Fulano de Tal"'
                                                : $pairValueType() == PairValueTypeValues.Number
                                                    ? 'e.g. 123'
                                                    : $pairValueType() == PairValueTypeValues.Boolean
                                                        ? 'e.g. true'
                                                        : $pairValueType() == PairValueTypeValues.Null
                                                            ? 'e.g. null'
                                                            : '[valor futuro do campo]';
                                    <div class="form-group mb-0">
                                        <label for="pairValue">Valor</label>
                                        <input type="{{$pairValueType() == PairValueTypeValues.Number ? 'number' : 'text'}}" class="form-control" id="pairValue" name="pairValue"
                                               [placeholder]="placeholderValue"
                                               [ngModel]="$pairValue()"
                                               [disabled]="shouldDisablePairValueInput()"
                                               [value]="$pairValueType() == PairValueTypeValues.Null ? 'null' : ''"
                                               (change)="$pairValue.set($event.target.value)"
                                        >
                                    </div>

                                    <button type="button" class="btn btn-outline-primary ml-2" (click)="addKeyValuePair()" (keyDown)="addKeyValuePair()">
                                        <i class="fas fa-plus-circle mr-2"></i>
                                        <span>Adicionar</span>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="subsection-label mb-2" for="addedKeyValuePairs">Pares de chave/valor adicionados</label>
                                <div class="key-value-pairs-container ml-4">
                                    @for (pair of $keyValuePairsArray(); track pair) {
                                        <div class="key-value-pair mr-2 mb-2 p-2">
                                            <pre class="m-0" [innerHtml]="prettyPrint(pair)"></pre>
                                            <i class="fas fa-trash-alt ml-2" matTooltip="Remover par de chave/valor" (click)="removeKeyValuePair(pair)" (keyDown)="removeKeyValuePair(pair)"></i>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    } @else {
                        <!-- Editar JSON completo -->
                        <div class="json-view-container ml-4">
                            <div class="form-group">
                                <label class="subsection-label mb-2" for="completeJson">Editar JSON completo</label>
                                <editor name="jsonToEdit" apiKey="no-api-key"
                                        [ngModel]="$jsonToEdit()"
                                        [init]="tinyMceOptions"
                                        (ngModelChange)="$jsonToEdit.set($event)"
                                ></editor>
                                <textarea id="tinyMce" class="d-none"></textarea>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

        <!-- Botões -->
        <div class="form-footer text-right mb-1">
            <hr class="mt-0"/>

            <!-- ConfigSchema -->
            <div class="button-wrapper float-left ml-1" featureHint="flowObjectDetails|ConfigSchemaButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-secondary" (click)="showConfigSchema()">Editar código-fonte</button>
            </div>

            <!-- Cancelar -->
            <div class="button-wrapper mr-2" featureHint="flowObjectDetails|CancelButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-danger" (click)="closeForm()">Cancelar</button>
            </div>

            <!-- Salvar -->
            <div class="button-wrapper" featureHint="flowObjectDetails|SaveButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="submit" class="btn btn-outline-primary"
                        [disabled]="!flowObjectMidwayOutboundApi.form.valid || $isReadOnlyMode()"
                >Salvar Rascunho</button>
            </div>
        </div>
    </form>

    <!-- Modal do ConfigSchema -->
    <ng-template #configSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="configSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(configSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(configSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$configSchemaFlat()" #configSchemaEditorRef></textarea>
    </ng-template>
}
